<template>
  <v-row>
      <Can I="readAll" a="SalesNote">
        <v-col cols="12">
          <!-- Top 5 Vendedores -->
          <div class="top-vendedores-wrapper">
              <v-card class="top-vendedores-card" elevation="1">
                  <v-card-title class="top-vendedores-header">
                      
                      <span class="top-vendedores-title">Top 5 Vendedores</span>
                  </v-card-title>
                  <v-card-text class="pa-4">
                      <div v-if="loading" class="seller-loading">
                          <div v-for="i in 5" :key="i" class="seller-card-loading">
                              <v-skeleton-loader type="card" height="200"></v-skeleton-loader>
                          </div>
                      </div>
                      <div v-else>
                          <div v-for="(seller, index) in topSellersList" :key="index" :class="getSellerCardClass(index)" class="seller-card">
                              <div class="seller-content">
                                  <div class="seller-ranking">
                                      <span class="ranking-number"># {{ index + 1 }}</span>
                                  </div>
                                  <div class="seller-info">
                                      <div class="seller-name">{{ seller.name }}</div>
                                      <div class="seller-amounts">
                                          <div class="amount-item">
                                              <!-- <div class="amount-label">Confirmado</div> -->
                                              <div class="amount-value">{{ seller.confirmed | moneda }}</div>
                                          </div>
                                          <!-- <div class="amount-item">
                                              <div class="amount-label">Facturado</div>
                                              <div class="amount-value">{{ seller.invoiced | moneda }}</div>
                                          </div> -->
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div v-if="topSellersList.length === 0" class="ga-empty-state">
                              <v-icon color="#9aa0a6" size="48" class="mb-3">mdi-database-off</v-icon>
                              <div class="ga-empty-text">No hay datos de vendedores para mostrar</div>
                              <div class="ga-empty-subtext">No se encontraron transacciones en el período seleccionado</div>
                          </div>
                      </div>
                  </v-card-text>
              </v-card>
          </div>
        </v-col>
      </Can>
    </v-row>
</template>

<script>


const numeral = require('numeral');
const moment = require('moment')
export default {
  name:'TopSellerList',

  props:['customers','sellers','loading'],
  data:()=>({
    topCustomersList: [],
    topSellersList: [],
  }),
  methods:{
    getSellerCardClass(index) {
      const classes = ['seller-cyan', 'seller-yellow', 'seller-pink', 'seller-cyan', 'seller-yellow'];
      return `seller-card-base ${classes[index] || 'seller-cyan'}`;
    },
    processData(){
      // Verificar que los datos existen
      if (!this.customers || !this.customers[0] || !this.customers[1] || 
          !this.sellers || !this.sellers[0] || !this.sellers[1]) {
        console.log('DayGraphComplete - Datos no disponibles:', { customers: this.customers, sellers: this.sellers })
        return
      }
      
      // Procesar datos de clientes
      const customerDataSet = this.customers[0].map(customer => {
        const invoicedCustomer = this.customers[1].find(c => c.customer__id === customer.customer__id)
        return {
          id: customer.customer__id,
          name: customer.name,
          confirmed: customer.total,
          invoiced: invoicedCustomer ? invoicedCustomer.total : 0
        }
      })
      
      // Procesar datos de vendedores
      const sellerDataSet = this.sellers[0].map(seller => {
        const invoicedSeller = this.sellers[1].find(s => s.customer__seller__id === seller.customer__seller__id)
        return {
          id: seller.customer__seller__id,
          name: seller.full_name,
          confirmed: seller.total,
          invoiced: invoicedSeller ? invoicedSeller.total : 0
        }
      })

      // Calcular total para porcentajes de vendedores
      const totalConfirmedSellers = sellerDataSet.reduce((sum, s) => sum + s.confirmed, 0);

      // Agregar porcentaje a vendedores
      const sellerDataSetWithPercentage = sellerDataSet.map(s => ({
        ...s,
        percentage: totalConfirmedSellers > 0 ? ((s.confirmed / totalConfirmedSellers) * 100).toFixed(1) : 0
      }));

      // Ordenar por confirmado y tomar top 5
      this.topCustomersList = customerDataSet
        .sort((a, b) => b.confirmed - a.confirmed)
        .slice(0, 5)

      this.topSellersList = sellerDataSetWithPercentage
        .sort((a, b) => b.confirmed - a.confirmed)
        .slice(0, 5)
      
      console.log('DayGraphComplete - Datos procesados:', {
        customers: this.topCustomersList,
        sellers: this.topSellersList
      })
    },
  },
  mounted() {
    // Siempre procesar datos de prueba
    this.processData()
  },
  watch:{
    //Revisa cambios en options para solicitar data nuevamente
    customers:{
      deep: true,
      handler: 'processData'
    },
    sellers:{
      deep: true,
      handler: 'processData'
    },
  },
}
</script>

<style scoped>
/* Estilos de las tarjetas de gráficos - Google Analytics 4 style */
.trends-chart-card {
  border-radius: 16px;
  border: 1px solid #e8eaed;
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.trends-chart-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.chart-title {
  padding: 24px 24px 0 24px;
  border-bottom: 1px solid #f1f3f4;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 16px 16px 0 0;
}

/* Estilos de la tabla - Google Analytics 4 style */
.ga-table {
  width: 100%;
}

.ga-header {
  display: grid;
  grid-template-columns: 40px 1fr 120px 120px;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #e8eaed;
  font-weight: 600;
  font-size: 0.875rem;
  color: #5f6368;
}

.ga-row {
  display: grid;
  grid-template-columns: 40px 1fr 120px 120px;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #f1f3f4;
  align-items: center;
  transition: background-color 0.2s ease;
}

.ga-row:hover {
  background-color: #f8f9fa;
}

.ga-rank {
  font-weight: 500;
  font-size: 0.875rem;
  color: #9aa0a6;
  text-align: center;
}

.ga-name {
  font-weight: 500;
  font-size: 0.875rem;
  color: #202124;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

 .ga-value {
   font-weight: 600;
   font-size: 0.875rem;
   color: #202124;
   text-align: right;
 }
 
 /* Estado vacío - Google Analytics 4 style */
 .ga-empty-state {
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   padding: 48px 24px;
   text-align: center;
 }
 
 .ga-empty-text {
   font-size: 1rem;
   font-weight: 500;
   color: #5f6368;
   margin-bottom: 8px;
 }
 
 .ga-empty-subtext {
   font-size: 0.875rem;
   color: #9aa0a6;
   line-height: 1.4;
 }

/* Top Vendedores Styles */
.top-vendedores-wrapper {
  margin-bottom: 0rem;
}

.top-vendedores-card {
  border-radius: 8px;
  border: 1px solid #e8eaed;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.top-vendedores-header {
  border-bottom: 1px solid #e8eaed;
  padding: 0px;
}

.top-vendedores-title {
  font-size: 1rem;
  font-weight: 600;
  color: #51535c;
  padding-left: 10px;
}

.seller-card-base {
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 10px;
  border: 1px solid;
}

.seller-cyan {
  background: #e0f7fa;
  border-color: #00bcd4;
}

.seller-yellow {
  background: #fffde7;
  border-color: #ffeb3b;
}

.seller-pink {
  background: #fce4ec;
  border-color: #e91e63;
}

.seller-content {
  display: flex;
  align-items: center;
  margin-bottom: 0px;
}

.seller-ranking {
  margin-right: 8px;
}

.ranking-number {
  font-size: 1.2rem;
  font-weight: 700;
  color: #202124;
  width: 28px;
  text-align: center;
}

.seller-info {
  flex: 1;
  display: flex;
  align-items: center;
}

.seller-name {
  font-size: 2.5rem;
  font-weight: 700;
  color: #202124;
  flex: 1;
}

.progress-container {
  width: 100%;
}

.progress-bar {
  width: 100%;
  height: 12px;
  background: white;
  border-radius: 6px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  border: 1px solid #e8eaed;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(to right, #00bcd4, #00acc1);
  transition: width 0.5s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.seller-amounts {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
}

.amount-item {
  text-align: right;
}

.amount-label {
  font-size: 0.7rem;
  color: #5f6368;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 0px;
}

.amount-value {
  font-size: 2.5rem;
  font-weight: 700;
  color: #202124;
}

.seller-loading {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.seller-card-loading {
  border-radius: 16px;
  overflow: hidden;
}

/* Responsive */

</style>

